(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-gold-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lb-gold-menu')) {
  customElements.define('lb-gold-menu', class extends HTMLElement {
    connectedCallback() {
      this.clearTimers();
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.items = [...this.querySelectorAll('.lb-gm-details')];
      this.area = this.closest('.header__wrapper') || this;
      this.hover = matchMedia('(hover:hover) and (pointer:fine)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.motion = {enter: 0, leave: 0, open: 600, close: 600};
      this.categoryHitWidth = 220;
      this.categoryHoverDelay = 180;

      this.items.forEach(item => {
        this.finishClose(item);
        item.querySelectorAll('.lb-cz-category').forEach(category => {
          const activate = () => {
            this.cancelCategoryHover();
            this.selectCategory(item, category.dataset.category);
          };
          const trackHover = event => {
            if (!this.hover.matches) return;
            if (!this.inCategoryHitArea(category, event.clientX, event.clientY)) {
              this.cancelCategoryHover();
              return;
            }
            if (item.dataset.category === category.dataset.category) {
              this.cancelCategoryHover();
              return;
            }
            if (this.pendingCategory === category) return;
            this.cancelCategoryHover();
            this.pendingCategory = category;
            this.categoryTimer = setTimeout(() => {
              this.pendingCategory = null;
              if (item.open && !item.lbClosing && category.matches(':hover')) activate();
            }, this.categoryHoverDelay);
          };
          category.addEventListener('pointerenter', trackHover, options);
          category.addEventListener('pointermove', trackHover, options);
          category.addEventListener('pointerleave', () => this.cancelCategoryHover(), options);
          category.addEventListener('focusin', activate, options);
          category.querySelector('.lb-cz-toggle')?.addEventListener('click', activate, options);
        });
        const summary = item.querySelector('summary');
        summary.addEventListener('click', event => {
          if (event.target.closest('a[href]')) { this.clearTimers(); return; }
          event.preventDefault();
          this.clearTimers();
          this.setOpen(item, !item.open || item.lbClosing);
        }, options);
        summary.addEventListener('pointerenter', () => {
          if (!this.hover.matches) return;
          this.keepOpen();
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.setOpen(item, true), this.motion.enter);
        }, options);
        summary.addEventListener('pointerleave', () => clearTimeout(this.openTimer), options);
        item.querySelector('.lb-gm-panel').addEventListener('pointerenter', () => this.keepOpen(), options);
      });

      this.querySelectorAll('.lb-gm-item > a.lb-gm-top').forEach(link => {
        link.addEventListener('pointerenter', () => {
          if (this.hover.matches) { this.clearTimers(); this.closeAll(); }
        }, options);
      });
      this.area.addEventListener('pointerenter', () => this.keepOpen(), options);
      this.area.addEventListener('pointerleave', () => {
        if (!this.hover.matches) return;
        this.clearTimers();
        this.closeTimer = setTimeout(() => {
          if (!this.area.matches(':hover')) this.closeAll();
        }, this.motion.leave);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const item = this.items.find(x => x.open);
        if (!item) return;
        event.preventDefault();
        this.clearTimers();
        item.querySelector('summary').focus({preventScroll: true});
        this.closeAll();
      }, options);
      this.addEventListener('focusin', () => this.keepOpen(), options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          this.clearTimers();
          this.closeAll();
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) {
          this.clearTimers();
          this.closeAll();
        }
      }, options);
      window.addEventListener('resize', () => {
        if (innerWidth < 1150) {
          this.clearTimers();
          this.items.forEach(item => this.finishClose(item));
        }
      }, options);
      this.reduced.addEventListener('change', () => {
        if (!this.reduced.matches) return;
        this.items.forEach(item => {
          if (item.lbClosing) this.finishClose(item);
          else { this.cancelMotion(item); this.cancelTextMotion(item); this.settleSubmenus(item); }
        });
      }, options);
    }

    inCategoryHitArea(category, x, y) {
      const rect = category.getBoundingClientRect();
      return x >= rect.left && x <= rect.left + Math.min(this.categoryHitWidth, rect.width)
        && y >= rect.top && y <= rect.bottom;
    }

    cancelCategoryHover() {
      clearTimeout(this.categoryTimer);
      this.pendingCategory = null;
    }

    selectCategory(item, key) {
      if (item.dataset.category === key) return;
      const next = [...item.querySelectorAll('.lb-cz-submenu')].find(list => list.dataset.submenu === key);
      if (!next) return;
      item.dataset.category = key;
      item.querySelectorAll('.lb-cz-category').forEach(category => {
        const active = category.dataset.category === key;
        category.classList.toggle('is-active', active);
        category.querySelector('.lb-cz-toggle')?.setAttribute('aria-expanded', String(active));
      });
      const lists = [...item.querySelectorAll('.lb-cz-submenu')];
      const previous = lists.find(list => !list.hidden);
      this.cancelSubmenuMotion(item);
      const reveal = () => {
        if (item.dataset.category !== key) return;
        lists.forEach(list => { list.hidden = list !== next; list.inert = list !== next; });
        item.querySelector('.lb-gm-panel').scrollTop = 0;
        if (next && !this.reduced.matches && item.open && !item.lbClosing) {
          this.animateTextTargets(item, [...next.querySelectorAll('.lb-card-item:not([hidden])')].map((element, index) => ({element, column: 0, row: Math.floor(index / 4)})), true, true, 0);
        }
      };
      if (!previous || previous === next || this.reduced.matches) { reveal(); return; }
      previous.inert = true;
      const fade = previous.animate([{opacity: getComputedStyle(previous).opacity}, {opacity: 0}],
        {duration: 130, easing: 'ease-out', fill: 'both'});
      item.lbSubmenuAnimation = fade;
      fade.onfinish = () => {
        if (item.lbSubmenuAnimation !== fade) return;
        previous.hidden = true;
        this.cancelSubmenuMotion(item);
        reveal();
      };
    }

    cancelSubmenuMotion(item) {
      if (item.lbSubmenuAnimation) {
        item.lbSubmenuAnimation.onfinish = null;
        item.lbSubmenuAnimation.cancel();
        item.lbSubmenuAnimation = null;
      }
    }

    settleSubmenus(item) {
      this.cancelSubmenuMotion(item);
      item.querySelectorAll('.lb-cz-submenu').forEach(list => {
        const active = list.dataset.submenu === item.dataset.category;
        list.hidden = !active;
        list.inert = !active;
      });
    }

    textTargets(item) {
      const groups = [
        [...item.querySelectorAll('.lb-cz-shortcuts li, .lb-cz-shortcuts > a')],
        [...item.querySelectorAll('.lb-cz-category')],
        [...item.querySelectorAll('.lb-cz-submenu:not([hidden]) .lb-card-item:not([hidden])')]
      ];
      return groups.flatMap((elements, column) => elements.map((element, row) => ({element, column, row: column === 2 ? Math.floor(row / 4) : row})));
    }

    cancelTextMotion(item) {
      item.lbTextAnimations?.forEach(animation => { animation.onfinish = null; animation.cancel(); });
      item.lbTextAnimations = new Map();
    }

    animateTextTargets(item, targets, open, fresh, baseDelay = 180) {
      item.lbTextAnimations ||= new Map();
      for (const {element, column, row} of targets) {
        const current = getComputedStyle(element);
        const start = {opacity: fresh ? '0' : current.opacity,
          transform: fresh ? 'translateY(8px)' : current.transform};
        const old = item.lbTextAnimations.get(element);
        if (old) { old.onfinish = null; old.cancel(); }
        const animation = element.animate([
          start,
          {opacity: open ? '1' : '0', transform: open ? 'translateY(0)' : 'translateY(-4px)'}
        ], {duration: open ? 300 : 140,
          delay: open ? baseDelay + column * 260 + row * 55 : 0,
          easing: open ? 'cubic-bezier(0.22,1,0.36,1)' : 'ease-out', fill: 'both'});
        item.lbTextAnimations.set(element, animation);
        animation.onfinish = () => {
          if (item.lbTextAnimations.get(element) !== animation || !open) return;
          animation.onfinish = null;
          animation.cancel();
          item.lbTextAnimations.delete(element);
        };
      }
    }

    clearTimers() {
      this.cancelCategoryHover();
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
    }

    keepOpen() {
      clearTimeout(this.closeTimer);
      // Only resume the intended menu, never an outgoing menu during a switch.
      if (this.activeItem?.lbClosing) this.setOpen(this.activeItem, true);
    }

    closeAll() {
      this.activeItem = null;
      this.items.forEach(item => this.reduced.matches ? this.finishClose(item) : this.setOpen(item, false));
    }

    cancelMotion(item) {
      (item.lbAnimations || []).forEach(animation => {
        animation.onfinish = null;
        animation.cancel();
      });
      item.lbAnimations = [];
    }

    setOpen(item, open) {
      if (open && item.open && !item.lbClosing) return;
      if (!open && (!item.open || item.lbClosing)) return;
      const panel = item.querySelector('.lb-gm-panel');
      const viewport = item.querySelector('.lb-gm-viewport');
      const wasOpen = item.open;
      const startTransform = wasOpen ? getComputedStyle(panel).transform : 'translateY(-105%)';
      this.cancelMotion(item);
      item.lbClosing = !open;
      if (open) {
        this.activeItem = item;
        // Both animations run together, as on LiThink. Never wait for the old one.
        this.items.filter(other => other !== item).forEach(other => this.setOpen(other, false));
        item.open = true;
        viewport.style.zIndex = '21';
        panel.inert = false;
        panel.style.pointerEvents = 'auto';
        if (!wasOpen) panel.scrollTop = 0;
        if (!item.dataset.category) {
          const first = item.querySelector('.lb-cz-submenu');
          if (first) this.selectCategory(item, first.dataset.submenu);
        }
      } else {
        if (panel.contains(document.activeElement)) {
          (this.activeItem || item).querySelector('summary').focus({preventScroll: true});
        }
        viewport.style.zIndex = '20';
        panel.inert = true;
        panel.style.pointerEvents = 'none';
      }
      this.settleSubmenus(item);
      if (!this.reduced.matches) this.animateTextTargets(item, this.textTargets(item), open, open && !wasOpen);
      else this.cancelTextMotion(item);
      item.querySelector('summary').setAttribute('aria-expanded', String(open));
      if (this.reduced.matches) {
        if (!open) this.finishClose(item);
        return;
      }
      const animation = panel.animate([
        {transform: startTransform === 'none' ? 'translateY(0)' : startTransform},
        {transform: open ? 'translateY(0)' : 'translateY(-105%)'}
      ], {
        duration: open ? this.motion.open : this.motion.close,
        easing: 'cubic-bezier(0.7,0,0.2,1)',
        fill: 'both'
      });
      item.lbAnimations = [animation];
      animation.onfinish = () => {
        if (item.lbAnimations?.[0] !== animation) return;
        if (open) this.cancelMotion(item);
        else this.finishClose(item);
      };
    }

    finishClose(item) {
      item.dataset.category = '';
      this.cancelMotion(item);
      this.cancelTextMotion(item);
      this.settleSubmenus(item);
      item.querySelectorAll('.lb-cz-category').forEach(category => {
        category.classList.remove('is-active');
        category.querySelector('.lb-cz-toggle')?.setAttribute('aria-expanded', 'false');
      });
      item.lbClosing = false;
      item.open = false;
      if (this.activeItem === item) this.activeItem = null;
      item.querySelector('summary').setAttribute('aria-expanded', 'false');
      const panel = item.querySelector('.lb-gm-panel');
      panel.inert = true;
      panel.style.pointerEvents = 'none';
    }

    disconnectedCallback() {
      this.clearTimers();
      this.abort?.abort();
      this.items?.forEach(item => this.finishClose(item));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-toggle')) {
    customElements.define('product-description-toggle', class extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('.main-product-v2-info__body');
        this.button = this.querySelector('.main-product-v2-info__toggle');
        this.label = this.querySelector('.main-product-v2-info__toggle-text');

        if (!this.body || !this.button || !this.label) return;

        this.abortController = new AbortController();
        this.button.addEventListener('click', () => this.toggleDescription(), {signal: this.abortController.signal});
        requestAnimationFrame(() => this.updateAvailability());

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => this.updateAvailability());
        }
      }

      get collapsedHeight() {
        const value = getComputedStyle(this).getPropertyValue('--description-collapsed-height');
        return Number.parseFloat(value) || 248;
      }

      updateAvailability() {
        if (this.classList.contains('is-expanded')) return;

        const needsToggle = this.body.scrollHeight > this.collapsedHeight + 2;
        this.classList.toggle('is-static', !needsToggle);
        this.button.hidden = !needsToggle;
        this.body.style.maxHeight = needsToggle ? `${this.collapsedHeight}px` : 'none';
      }

      toggleDescription() {
        const expanded = this.classList.contains('is-expanded');

        if (expanded) {
          this.body.style.maxHeight = `${this.body.scrollHeight}px`;
          this.body.offsetHeight;
          this.classList.remove('is-expanded');
          requestAnimationFrame(() => {
            this.body.style.maxHeight = `${this.collapsedHeight}px`;
          });
        } else {
          this.classList.add('is-expanded');
          this.body.style.maxHeight = `${this.body.scrollHeight}px`;
          this.body.addEventListener('transitionend', () => {
            if (this.classList.contains('is-expanded')) this.body.style.maxHeight = 'none';
          }, {once: true});
        }

        const isExpanded = !expanded;
        this.button.setAttribute('aria-expanded', String(isExpanded));
        this.label.textContent = isExpanded ? this.button.dataset.showLess : this.button.dataset.showMore;
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
